import { ApiCaseGroup } from '../api-types/case-group.api';
import { CaseGroup } from '../app-types/case-group';

/**
 * Transforms an ApiCaseGroup object to an app-specific CaseGroup object.
 * @description This function maps properties of the ApiCaseGroup to the CaseGroup interface.
 * It is used to convert data received from the API into a format that the application can work with.
 * @param input ApiCaseGroup
 * @returns CaseGroup
 */
export const transformApiCaseGroupToAppCaseGroup = (input: ApiCaseGroup) => {
	const output: CaseGroup = {
		id: input.id,
		description: input.description,
	};
	return output;
};

/**
 * Transforms an array of ApiCaseGroup objects to an array of app-specific
 * CaseGroup objects.
 * @param input Array of ApiCaseGroup objects
 * @description Transforms an array of ApiCaseGroup objects to an array of app-specific CaseGroup objects.
 * @returns Array of app-specific CaseGroup objects
 */
export const transformApiCaseGroupsToAppCaseGroups = (input: ApiCaseGroup[]) => {
	const output: CaseGroup[] = input.map(transformApiCaseGroupToAppCaseGroup);
	return output;
};
